export const AscyncSleep = (ms) => new Promise((r) => setTimeout(r, ms));
